import { useEffect } from 'react';
import { navigate } from 'gatsby';
import { readStoredAuthToken } from 'lib/auth-token-storage';
import { useAuthStore } from 'stores/auth-store';

function buildLoginRedirect(redirectPath) {
  return `/login?redirect=${encodeURIComponent(redirectPath)}`;
}

/**
 * Protects routes that need user + workshop customer in memory (not localStorage).
 * Waits for token bootstrap, then redirects to login if profile is missing.
 */
export function useRequireWorkshopSession(redirectPath = '/catalogue/') {
  const token = useAuthStore((state) => state.token);
  const phone = useAuthStore((state) => state.phone);
  const user = useAuthStore((state) => state.user);
  const workshopCustomer = useAuthStore((state) => state.workshopCustomer);

  const bootstrapping = Boolean(
    (token?.trim() || readStoredAuthToken()) && !phone?.trim(),
  );
  const hasProfile = Boolean(user && workshopCustomer);

  useEffect(() => {
    if (bootstrapping) {
      return;
    }

    if (!hasProfile) {
      navigate(buildLoginRedirect(redirectPath));
    }
  }, [bootstrapping, hasProfile, redirectPath]);

  return {
    ready: !bootstrapping && hasProfile,
    bootstrapping,
  };
}
